export default "__VITE_ASSET__DSkd3_yI__"